import React, { useEffect, useState} from 'react';
import {Controller, useForm} from "react-hook-form";
import {
    Button,
    CardText,
    Col,
    FormFeedback,
    Input,
    Label,
    Modal,
    ModalBody,
    ModalHeader,
    Row,
    Spinner
} from "reactstrap";
import {Eye} from "react-feather";
import AreaFilter from "../../area/components/filter-area/area-filter";
import RoleList from "../roles/role-list";
import axios from "axios";
import toast from "react-hot-toast";

const EditUser = ({createOpts, editOpts, handleClose, item}) => {
    const [loading, setLoading] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const [title, setTitle] = useState("");
    const [selectedAreas, setSelectedAreas] = useState([]);
    const [selectedRole, setSelectedRole] = useState("");
    const [checked, setChecked] = useState(false);
    const [passwordValue, setPasswordValue] = useState("");
    const [error, setErrors] = useState({
        userName: "",
        email: "",
        areas: "",
        role: "",
        password: ""
    });
    const [formError, setFormError] = useState("");
    const handleAreaChange = (selectedOptions) => {
        setSelectedAreas(selectedOptions);
    };

    const handleRoleChange = (selectedOption) => {
        setSelectedRole(selectedOption);
    };

    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };

    const defaultValues = {
        userName: "",
        isActive: true,
        role: "",
        email: "",
        area: []
    };

    const {
        control,
        handleSubmit,
        setValue,
        reset,
        formState: { errors }
    } = useForm({ defaultValues });

    useEffect(() => {
        console.log(checked);
        setValue('isActive', checked);
    }, [checked]);

    useEffect(() => {
        if (item) {
            setValue('userName', item.userName);
            setValue('isActive', item?.isActive);
            setValue('role', item.role);
            setValue('areas', item.areas);
            setValue('email', item.email);
            setChecked(item?.isActive);
        }
    }, [item])

    useEffect(() => {
        if (createOpts) {
            setTitle('Crear Usuario');
            setValue('userName', undefined);
            setValue('isActive', true);
            setValue('role', undefined);
            setSelectedAreas([]);
            setSelectedRole("");
            setValue('email', undefined);
        } else {
            setValue('userName', item?.userName);
            setValue('isActive', item ? item?.isActive : true);
            setValue('role', item?.role);
            setValue('areas', item?.areas);
            setValue('email', item?.email);
            setTitle('Editar Usuario');
            setSelectedAreas(item?.areas);
            setSelectedRole(item?.role);
            setChecked(item?.isActive);
        }
    }, [createOpts, editOpts])

    const handlePasswordChange = (e) => {

        if (checkRegex(e.target.value)) {
            setErrors({...error, password: "Debe tener al menos 8 caracteres, que incluyen 1 carácter especial y 1 letra mayúscula"});
        } else {
            setErrors({...error, password: ""});
        }
        setPasswordValue(e.target.value);
    };

    const checkRegex = (str) => {
        const regex = /^(?=.*[A-Z])(?=.*[\W_]).{9,}$/i;

        return (!regex.test(str));
    }

    const onClose = () => {
        setErrors({
            userName: "",
            email: "",
            areas: "",
            role: ""
        })
        setFormError("");

        if (createOpts) {
            reset();
            setSelectedAreas([]);
            setSelectedRole("");
            setPasswordValue("");
        } else {
            setPasswordValue("");
        }
        handleClose(true);
    }

    const createUser = async (data) => {
        const roles = JSON.parse(localStorage.getItem("roles"));
        const payload = {
            name: data.userName,
            email: data.email,
            password: passwordValue,
            areas: selectedAreas.map(area => area.value|| area.id),
            role: roles.find(role => role.label === selectedRole.label).value ||
                roles.find(role => role.label === selectedRole)?.value,
            isActive: checked
        };

        console.log(payload);
        return await axios.post(`${process.env.REACT_APP_API_URL}/users`, payload);
    }

    const editUser = async (data) => {
        const roles = JSON.parse(localStorage.getItem("roles"));
        const payload = {
            name: data.userName,
            email: data.email,
            areas: data.areas?.map(area => area.value || area.id),
            role: roles.find(role => role.label === selectedRole.label)?.value ||
                roles.find(role => role.label === selectedRole)?.value,
            isActive: checked
        };

        if (passwordValue) {
            payload.password = passwordValue;
        }

        return await axios.put(`${process.env.REACT_APP_API_URL}/users/${item.noUser}`, payload);
    }

    const onSubmit = async (data) => {
        data.areas = selectedAreas?.length === 0 ? item?.areas : selectedAreas
        data.role = selectedRole ? selectedRole : item?.role
        data.isActive = checked;
        console.log(data.isActive);

        const passwordRegex = (createOpts && checkRegex(passwordValue)) || (!createOpts && (passwordValue && checkRegex(passwordValue)));
        if (selectedAreas?.length === 0 || !data.role ||
            !data.userName || !data.email ||
            error.userName || error.email || passwordRegex) {
            setErrors({
                userName: data?.userName ? "" : "El nombre de usuario no debe estar vacío",
                email: data?.email ? "" : "El correo electrónico no debe estar vacío",
                areas: selectedAreas?.length === 0 ? "seleccione al menos un área" : "",
                role: selectedRole ? "" : "seleccione un rol",
                password: !passwordRegex ? "" : "Debe tener al menos 8 caracteres, que incluyen 1 carácter especial y 1 letra mayúscula"
            })
            setFormError("Corregir errores para continuar");
            return;
        } else {
            setFormError("");
        }
        try {
            setLoading(true);
            let res;
            if (createOpts) {
                const resList =  await axios.get(`${process.env.REACT_APP_API_URL}/users`);
                if (resList.data.data.find(user => user.email === data?.email)) {
                    toast.error(`El correo "${data?.email}" ya se encuentra registrado`);
                    setLoading(false);
                    return;
                }
                res = await createUser(data);
            } else {
                // change when put endpoint is available
                setLoading(false);
                res = await editUser(data);
            }
            if (res.data.header.code) {
                toast.success(`Usuario ${createOpts ? 'creada': 'editada'}  con exito!`);
                setTimeout(() => window.location.reload(), 1000);
            } else {
                setLoading(false);
                toast.error(res.data.header.message);
                reset();
            }
        } catch (e) {
            setLoading(false);
            toast.error(`Ha ocurrido un error: ${e.response?.data?.title || e.message}`);
            reset();
        }
    }

    const setIsChecked = (e) => {
        setChecked( e.target.checked);
        console.log("here")
    }
    return (
        <Modal isOpen={createOpts || editOpts} toggle={() => handleClose(false)} className='modal-dialog-centered modal-lg'>
            <ModalHeader className='bg-transparent' toggle={() => onClose()}></ModalHeader>
            <ModalBody className='px-sm-5 mx-50 pb-5'>
                <div className='text-center mb-2'>
                    <h1 className='mb-1'>{ title }</h1>
                    <p>{ createOpts ? 'Agregar nueva información de usuario' : 'Editar información del usuario'}</p>
                </div>

                {loading ? <Row>
                    <div className='col-12 px-2 py-4 text-center'>
                        <Spinner size='lg'/>
                        <CardText className={'py-1 fs-5'}>Creando sociedad...</CardText>
                    </div>
                </Row> : <Row tag='form' className='gy-1 pt-75' onSubmit={handleSubmit(onSubmit)}>
                    <Col md={6} xs={12}>
                        <Label className='form-label' for='userName'>
                            Nombre de usuario *
                        </Label>
                        <Controller
                            control={control}
                            name='userName'
                            render={({ field }) => {
                                return (
                                    <Input
                                        {...field}
                                        id='userName'
                                        placeholder='John Cardenas'
                                        value={field.value}
                                        onChange={e => {
                                            const value = e.target.value;
                                            if (value.length === 0) {
                                                setErrors(
                                                    { ...error, userName: 'El nombre de usuario no debe estar vacío' }
                                                )
                                            } else {
                                                setErrors(
                                                    { ...error, userName: '' }
                                                )
                                            }
                                            field.onChange(e);
                                        }}
                                    />
                                )
                            }}
                        />
                        {error.userName && <div style={{ color: 'red' }}>{error.userName}</div>}
                    </Col>
                    <Col md={6} xs={12}>
                        <Label className='form-label' for='email'>
                            Correo de usuario *
                        </Label>

                        <Controller
                            name='email'
                            control={control}
                            render={({field}) => <Input
                                type='email'
                                id='email'
                                placeholder='john.doe@example.com'
                                invalid={errors.email && true} {...field}
                                onChange={e => {
                                    const value = e.target.value;
                                    if (value.length === 0) {
                                        setErrors(
                                            { ...error, email: 'El correo electrónico no debe estar vacío' }
                                        )
                                    } else {
                                        setErrors(
                                            { ...error, email: '' }
                                        )
                                    }
                                    field.onChange(e);
                                }}
                            />}
                        />
                        {error.email && <div style={{ color: 'red' }}>{error.email}</div>}
                    </Col>
                    <Col md={6} xs={12}>
                        <Label className='form-label' for='contrasena'>
                            Contraseña temporal {createOpts ? "*": ""}
                        </Label>

                        <div className='input-group'>
                            <Input
                                type={showPassword ? 'text' : 'password'}
                                id='password'
                                placeholder='Escribe tu contraseña'
                                value={passwordValue}
                                onChange={handlePasswordChange}
                                autocomplete="off"
                            />
                            <button
                                className='input-group-text password-toggle-button'
                                onClick={togglePasswordVisibility}
                                type="button"
                                disabled={!passwordValue}
                            >
                                <Eye onClick={() => togglePasswordVisibility} size={20} />
                            </button>

                            {error.password && <div style={{ color: 'red' }}>{error.password}</div>}
                        </div>
                        {errors.documentType && <FormFeedback>Por favor seleccione un Contraseña valido</FormFeedback>}

                    </Col>
                    <Col md={6} xs={12}>
                        <AreaFilter onAreaChange={handleAreaChange} valueList={createOpts ? [] : item?.areas} hiddenArea='none'/>
                        {error.areas && <div style={{ color: 'red' }}>{error.areas}</div>}
                    </Col>
                    <Col md={6} xs={12}>
                        <RoleList onRoleChange={handleRoleChange} value={createOpts ? '' : item?.role}/>
                        {error.role && <div style={{ color: 'red' }}>{error.role}</div>}
                    </Col>
                    <Col md={6} xs={12} style={{"margin-top":"6%"}}>
                        <Label className='form-label' for='active'>
                            Activo
                        </Label>
                        <Controller
                            id='active'
                            name='active'
                            control={control}
                            render={({field}) => (
                                <Input className={'cursor-pointer'} type='checkbox'
                                       checked={checked} onChange={setIsChecked}
                                       style={{"margin-left": "2%"}}/>
                            )}
                        />
                        {errors.phone && <FormFeedback>El numero teléfono es obligatorio</FormFeedback>}
                    </Col>

                    <Col md={12} xs={12}>
                        <small className={'text-secondary'}>
                            Campos obligatorios (*)
                        </small>
                    </Col>
                    {formError && <div style={{ color: 'red' }}>{formError}</div>}


                    <Col xs={12} className='text-center mt-2 pt-50'>
                        <Button type='submit' className='me-1' color='primary'>
                            Guardar
                        </Button>
                        <Button type='reset' color='secondary' outline onClick={() => onClose()}>
                            Cancelar
                        </Button>
                    </Col>
                </Row>}
            </ModalBody>
        </Modal>
    );
}

export default EditUser;